"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTeamPackage = exports.isEnterprisePackage = exports.isBasicPackage = exports.isAnnualPackage = exports.PackageType = void 0;
// constants and logic for dealing with billing packages
var PackageType;
exports.PackageType = PackageType;
(function (PackageType) {
  PackageType[PackageType["BASIC"] = 1] = "BASIC";
  PackageType[PackageType["PRO"] = 2] = "PRO";
  PackageType[PackageType["UNLIMITED"] = 3] = "UNLIMITED";
  PackageType[PackageType["SELECT_MONTHLY"] = 4] = "SELECT_MONTHLY";
  PackageType[PackageType["GOLD"] = 5] = "GOLD";
  PackageType[PackageType["PLATINUM"] = 6] = "PLATINUM";
  PackageType[PackageType["SELECT_YEARLY"] = 7] = "SELECT_YEARLY";
  PackageType[PackageType["TEMP_PRO"] = 8] = "TEMP_PRO";
  PackageType[PackageType["PRO_COMP"] = 9] = "PRO_COMP";
  PackageType[PackageType["ZOOM_PRO"] = 13] = "ZOOM_PRO";
  PackageType[PackageType["ZOOM_PREMIUM"] = 16] = "ZOOM_PREMIUM";
  PackageType[PackageType["ENT_GOLD"] = 25] = "ENT_GOLD";
  PackageType[PackageType["ENTERPRISE_PLATINUM"] = 26] = "ENTERPRISE_PLATINUM";
  PackageType[PackageType["ENTERPRISE"] = 27] = "ENTERPRISE";
  PackageType[PackageType["ENTERPRISE_CASUAL_USER"] = 29] = "ENTERPRISE_CASUAL_USER";
  PackageType[PackageType["STANDARD_MONTHLY"] = 31] = "STANDARD_MONTHLY";
  PackageType[PackageType["STANDARD_ANNUAL"] = 32] = "STANDARD_ANNUAL";
  PackageType[PackageType["ADVANTAGE_MONTHLY"] = 33] = "ADVANTAGE_MONTHLY";
  PackageType[PackageType["ADVANTAGE_ANNUAL"] = 34] = "ADVANTAGE_ANNUAL";
  PackageType[PackageType["PREMIER_MONTHLY"] = 35] = "PREMIER_MONTHLY";
  PackageType[PackageType["PREMIER_ANNUAL"] = 36] = "PREMIER_ANNUAL";
  PackageType[PackageType["ANALYZE_PACKAGE"] = 37] = "ANALYZE_PACKAGE";
  PackageType[PackageType["TEAM_ADVANTAGE_ANNUAL"] = 134] = "TEAM_ADVANTAGE_ANNUAL";
  PackageType[PackageType["TEAM_PREMIER_ANNUAL"] = 136] = "TEAM_PREMIER_ANNUAL";
  PackageType[PackageType["ENTERPRISE_CONTRIBUTOR_SEAT"] = 226] = "ENTERPRISE_CONTRIBUTOR_SEAT";
  PackageType[PackageType["TEAM_ADVANTAGE_CONTRIBUTOR_SEAT"] = 234] = "TEAM_ADVANTAGE_CONTRIBUTOR_SEAT";
  PackageType[PackageType["TEAM_PREMIER_CONTRIBUTOR_SEAT"] = 236] = "TEAM_PREMIER_CONTRIBUTOR_SEAT";
})(PackageType || (exports.PackageType = PackageType = {}));
var isAnnualPackage = function isAnnualPackage(packageID) {
  return [PackageType.ENTERPRISE_PLATINUM, PackageType.ENTERPRISE, PackageType.STANDARD_ANNUAL, PackageType.ADVANTAGE_ANNUAL, PackageType.PREMIER_ANNUAL, PackageType.TEAM_ADVANTAGE_ANNUAL, PackageType.TEAM_PREMIER_ANNUAL].includes(packageID);
};
exports.isAnnualPackage = isAnnualPackage;
var isBasicPackage = function isBasicPackage(packageID) {
  return packageID === PackageType.BASIC;
};
exports.isBasicPackage = isBasicPackage;
var isEnterprisePackage = function isEnterprisePackage(packageID) {
  return [PackageType.ENT_GOLD, PackageType.ENTERPRISE, PackageType.ENTERPRISE_CONTRIBUTOR_SEAT, PackageType.ENTERPRISE_PLATINUM, PackageType.ENTERPRISE_CASUAL_USER].includes(packageID);
};
exports.isEnterprisePackage = isEnterprisePackage;
var isTeamPackage = function isTeamPackage(packageID) {
  return [PackageType.ENTERPRISE_PLATINUM, PackageType.ENTERPRISE, PackageType.TEAM_ADVANTAGE_ANNUAL, PackageType.TEAM_PREMIER_ANNUAL].indexOf(packageID) > -1;
};
exports.isTeamPackage = isTeamPackage;
//# sourceMappingURL=index.js.map